import CheckCircleIcon from '@mui/icons-material/CheckCircle'
import DoNotDisturbOnIcon from '@mui/icons-material/DoNotDisturbOn'
import { StatusChip } from '../../../customComponents/StatusChip'

export const StatusPill = ({ value }: { value: string }): JSX.Element => {
  if (value === 'Yes') return <StatusChip label='Yes' icon={<CheckCircleIcon />} iconColor='var(--green-500)' />
  if (value === 'No') return <StatusChip label='No' icon={<DoNotDisturbOnIcon />} iconColor='var(--red-700)' />
  return <StatusChip label={value.startsWith('N/A') ? 'NA' : value} />
}
